/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-08-25 14:19:17
 */
import piexif from 'piexifjs'
import {
  createImageWithDataURL,
  readFileAsDataUrl
} from '../../../utils/imageUtils'

export const readUserComment = async (url: string) => {
  const dataUrl = await fetch(url)
    .then((res) => res.blob())
    .then((blob) => readFileAsDataUrl(blob as File))
  const exifObj = piexif.load(dataUrl)
  const userComment = exifObj['Exif'][piexif.ExifIFD.UserComment]

  if (userComment) {
    console.log(18, userComment)
    return userComment.replace(/ASCII/, '').replace(/\x00{3}/, '')
  } else {
    return ''
  }
}

export const notTodayCameraShotUserComment = {
  data2: {
    userID: '',
    fileName: ''
  }
}

// EXIF 信息类型定义
export interface ExifInfo {
  dateTimeOriginal?: string
  make?: string
  model?: string
  userComment?: string
  gps?: Record<string, unknown>
  width?: number
  height?: number
}

export const readExif = async (file: File): Promise<ExifInfo> => {
  try {
    const dataUrl = await readFileAsDataUrl(file)
    const exifObj = piexif.load(dataUrl)
    const exif = exifObj['Exif']
    const gps = exifObj['GPS']
    const userComment = exif[piexif.ExifIFD.UserComment]
    const image = await createImageWithDataURL(dataUrl) as HTMLImageElement
    const exifInfo: ExifInfo = {
      // 照片拍摄时间
      dateTimeOriginal: exif[piexif.ExifIFD.DateTimeOriginal],
      // 照片拍摄设备
      make: exif[piexif.ExifIFD.Make],
      // 照片拍摄设备型号
      model: exif[piexif.ExifIFD.Model],
      // 照片拍摄设备型号
      userComment: userComment?.replace(/ASCII/, '')?.replace(/\x00/g, ''),
      // 照片拍摄设备型号
      gps: gps,
      // 照片宽高
      width: image.width,
      height: image.height
    }
    return exifInfo
  } catch (e) {
    console.log(e)
    console.log('file', file)

    return {}
  }
}
